import React, { useState } from 'react';
import { DivideIcon as LucideIcon } from 'lucide-react';

interface ProcessStepProps {
  icon: LucideIcon;
  title: string;
  description: string;
  gradient: string;
  stepNumber: number;
  delay: number;
}

const ProcessStep: React.FC<ProcessStepProps> = ({
  icon: Icon,
  title,
  description,
  gradient,
  stepNumber,
  delay
}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={`relative bg-slate-800/50 backdrop-blur-xl border border-slate-700/50 rounded-2xl p-8 pt-12 text-center hover:border-indigo-500/50 transition-all duration-500 cursor-pointer ${
        isHovered ? 'transform -translate-y-3 shadow-2xl' : 'shadow-lg'
      }`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{ animationDelay: `${delay}ms` }}
    >
      {/* Step number badge */}
      <div className={`absolute -top-5 left-1/2 transform -translate-x-1/2 w-10 h-10 bg-gradient-to-br ${gradient} rounded-full flex items-center justify-center text-white font-bold shadow-lg group-hover:scale-110 transition-transform duration-300`}>
        {stepNumber}
      </div>
      
      {/* Background gradient effect */}
      <div className={`absolute inset-0 bg-gradient-to-br ${gradient} opacity-0 hover:opacity-5 rounded-2xl transition-opacity duration-500`}></div>
      
      {/* Icon */}
      <div className="mb-6 flex justify-center">
        <Icon className={`w-12 h-12 text-slate-400 group-hover:text-transparent group-hover:bg-gradient-to-br group-hover:${gradient} group-hover:bg-clip-text transition-all duration-300`} />
      </div>
      
      {/* Content */}
      <h3 className="text-xl font-bold text-white mb-4">
        {title}
      </h3>
      
      <p className="text-slate-300 leading-relaxed">
        {description}
      </p>
      
      {/* Progress indicator */}
      <div className="mt-6 flex justify-center">
        <div className={`w-16 h-1 bg-gradient-to-r ${gradient} rounded-full opacity-50 group-hover:opacity-100 transition-opacity duration-300`}></div>
      </div>
    </div>
  );
};

export default ProcessStep;